import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {withTranslation, WithTranslation} from 'react-i18next'
import SimpleTable, {CellData, ColumnCell, ColumnsSource, RowData, RowsDataSource, TableData} from './simple-table';
import {EmployeeReport, EmployeesReport} from '../stores/employee-report-store';

interface EmployeesReportTableProps extends WithTranslation {
    data: EmployeesReport,
    onDownload?: (format: string) => Promise<boolean>,
    colors: string[],
    showBar?: boolean,
    showLine?: boolean,
    showPie?: boolean
}

interface EmployeesReportTableState {
    data: EmployeesReport,
    colors: string[],
    isBusy: boolean,
    showConfirmModal: boolean,
}

class EmployeeReportTable extends Component<EmployeesReportTableProps, EmployeesReportTableState> {
    constructor(props: EmployeesReportTableProps) {
        super(props);
        this.state = {
            data: props.data,
            colors: props.colors,
            showConfirmModal: false,
            isBusy: false
        }
    }

    private parseTime(h: any, format?: any) {
        if (format == null) {
            var hours = parseFloat(h).toFixed(2)
            return `${hours} hrs`
        }
    }

    @autobind
    private buildTableData(projectIdToName: Map<string, string>, reports: EmployeeReport[]): TableData {
        const { t } = this.props

        var projectIds: string[] = []
        var projectNames: string[] = []
        projectIdToName.forEach((name, id) => {
            projectIds.push(id)
            projectNames.push(name)
        })

        var rowsDataSource: RowsDataSource = {
            title: "Employees",
            items: reports.map(report => { return { title: report.employeeName, cells: [], key: undefined } as RowData }),
            render: (cell: CellData) => { return <span className={'timesheet-item'} style={{ padding: 5 }}> {this.parseTime(cell.value)}</span> }
        }
        var columnsSource: ColumnsSource = {
            items: [],
            render: (columnCell) => { return <span style={{ padding: 5 }}> {columnCell.value} </span> }
        }

        projectIds.map((pid, index) => {
            reports.forEach((report, i) => {
                rowsDataSource.items[i].key = report.employeeId
                rowsDataSource.items[i].cells.push({ value: report.workedHoursPerProject.get(pid) ?? 0 })
                if (index == projectIds.length - 1) {
                    rowsDataSource.items[i].cells.push({ value: report.totalWorkedHours })
                }
            })

            columnsSource.items.push({
                key: pid,
                value: projectNames[index]
            } as ColumnCell)
        })
        columnsSource.items.push({ key: "1", value: t("Total") })

        return {
            columnsSource: columnsSource,
            rowsSource: rowsDataSource
        } as TableData
    }

    render() {
        let data = this.buildTableData(this.state.data.projectIdToName, this.state.data.reports)
        return <SimpleTable data={data} onDownload={this.props.onDownload} downloadTypeStandard={"perProject-Standard"} downloadTypeMatrix={"perProject-Matrix"} />
    }
}
export default withTranslation()(EmployeeReportTable);